export const FIXED_COLUMN_LEFT_SIDE = 'left';
export const FIXED_COLUMN_RIGHT_SIDE = 'right';
export const TABLE_FIXED_TYPE = Symbol('fixed');
